export default {"src":"/_next/static/media/winner_left_new.6c2fabee.svg","height":150,"width":240,"blurWidth":0,"blurHeight":0};